module.exports = __webpack_public_path__ + "static/serverless-dashboard-d696c6e4d4c2efb8f9ebfa09b9757a38.gif";